import React, { Component } from 'react';
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";

export default class AsrBuild extends Component {
    constructor() {
        super();
        this.state = {
            voicePercentage: 0,
            status: null,
            voiceStatus: null,
            voiceProgressBar: false,
            details: "",
            lastBuildDate: "",
            recordsPresent: false,
            isCleanBuild: false,
            isVoiceBuildInProgress: false,
        }
    }

    notifyGeneralErrorMessage() {
        toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyBuildStatusFetchError() {
        toast(<b style={{ color: "red" }}>Snap! Some error occured when trying to get build status...</b>, {
            position: "top-center",
            color: "red"

        });
    }

    startBuildingOfTheProject = () => {
        let thisController = this;
        thisController.state.isVoiceBuildInProgress = true;
        thisController.setState(thisController.state);
        let data = {
            projectId: localStorage.getItem("currentProjectId")
        }
        $.ajax({
            url: "/api/asr-start-build",
            type: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    if (res.result != null) {
                        res = res.result;
                        thisController.state.voicePercentage = res.percentage;
                        thisController.state.buildId = res.id;
                        thisController.state.startTime = res.startTime;
                        thisController.state.voiceStatus = res.status;
                        thisController.setState(thisController.state);
                        if (res.status != 'COMPLETE') {
                            window.voiceBuildStatusTimeoutHandle = setInterval(function () {
                                thisController.voiceBuildStatus(res.id);
                            }, 1000);
                        }
                    } else {
                        thisController.state.isVoiceBuildInProgress = false;
                        thisController.state.voiceProgressBar = false;
                        thisController.setState(thisController.state);
                        thisController.notifyGeneralErrorMessage();
                    }
                } else {
                    thisController.state.isVoiceBuildInProgress = false;
                    thisController.state.voiceProgressBar = false;
                    thisController.setState(thisController.state);
                    thisController.notifyGeneralErrorMessage();
                }
            }
        });
    }


    voiceBuildStatus = (voiceBuildId) => {
        let thisController = this;
        thisController.state.isVoiceBuildInProgress = true;
        thisController.setState(thisController.state);
        $.ajax({
            url: "/api/asr-build-status",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            data: {
                buildId: voiceBuildId
            },
            success: function (res) {
                if (res.success === true) {
                    res = res.result;
                    thisController.state.voicePercentage = res.percentage;
                    thisController.state.voiceStatus = res.status;
                    thisController.state.details = res.details;
                    if (res.status == 'COMPLETE') {
                        clearTimeout(window.voiceBuildStatusTimeoutHandle);
                        thisController.state.isVoiceBuildInProgress = false;
                    } else if (res.status == 'ERROR') {
                        clearTimeout(window.voiceBuildStatusTimeoutHandle);
                        thisController.state.isVoiceBuildInProgress = false;
                        thisController.setState({
                            voiceProgressBar: false
                        });
                        thisController.notifyBuildStatusFetchError();
                    }
                    thisController.setState(thisController.state);
                } else {
                    thisController.state.isVoiceBuildInProgress = false;
                    thisController.setState({
                        voiceProgressBar: false
                    });
                    thisController.notifyBuildStatusFetchError();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    onBuildButton = (data) => {
        var buildController = this;
        buildController.startBuildingOfTheProject();
        buildController.setState({
            voiceProgressBar: true
        });
    }

    setLastBuildInfo = (response) => {
        var buildController = this;
        var date = new Date(response.startTime);
        var lastBuildDate = date.toLocaleString();
        buildController.state.recordsPresent = true;
        buildController.state.lastBuildDate = lastBuildDate;
        buildController.state.voiceStatus = response.status;
        buildController.setState(buildController);
    }

    fetchBuildInfoDataApi(projectId) {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
              projectId = localStorage.getItem('currentProjectId');
            }
          }
        var thisController = this;
        $.ajax({
            url: "/api/asr-last-build-info",
            async: false,
            method: 'GET',
            data: { "projectId": projectId },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.lastVoiceBuildInfo === null) {
                        thisController.state.voiceProgressBar = false;
                        thisController.state.recordsPresent = false;
                        thisController.setState(thisController);
                    } else {
                        thisController.setLastBuildInfo(res.result.lastVoiceBuildInfo)
                        var today = new Date();
                        var currentTime = today.getTime();
                        var differenceBtwTime = (currentTime - res.result.lastVoiceBuildInfo.startTime) / 60000;
                        var isVoiceProgress = false;
                        if (differenceBtwTime <= 20) {
                            if (res.result.lastVoiceBuildInfo != null) {
                                if (res.result.lastVoiceBuildInfo.status === 'COMPLETE' ||
                                    res.result.lastVoiceBuildInfo.status === 'ERROR') {
                                    isVoiceProgress = false;
                                } else {
                                    isVoiceProgress = true;
                                }

                                if (isVoiceProgress) {
                                    thisController.state.voiceProgressBar = true;
                                    window.voiceBuildStatusTimeoutHandle = setInterval(function () {
                                        thisController.voiceBuildStatus(res.result.lastVoiceBuildInfo.id);
                                    }, 1000);
                                } else {
                                    thisController.state.voiceProgressBar = true;
                                    thisController.state.voiceStatus = res.result.lastVoiceBuildInfo.status;
                                    thisController.state.voicePercentage = res.result.lastVoiceBuildInfo.percentage;
                                    thisController.state.details = res.result.lastVoiceBuildInfo.details;
                                }
                                thisController.setState(thisController.state);
                            }
                        }
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }


    componentDidMount() {
        var thisController = this;
        setTimeout(() => {
            this.fetchBuildInfoDataApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchBuildInfoDataApi(event.projectId);
        });
    }

    componentWillUnmount() {
        clearTimeout(window.voiceBuildStatusTimeoutHandle)
    }

    render() {
        var voiceStatus = this.state.voiceStatus;
        if (voiceStatus != null || voiceStatus != undefined) {
            if (/_/i.test(voiceStatus)) {
                var replUnSc = voiceStatus.split("_").join(" ");
                voiceStatus = replUnSc.split(' ')
                    .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
                    .join(' ')
            } else {
                voiceStatus = voiceStatus[0].toUpperCase() + voiceStatus.substr(1).toLowerCase()
            }
        }
        return (
            <div>
                {/* for toaster */}
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <div style={{ marginRight: '1%' }}>

                    {/*---------------SUB-TITLE--------------------------------------------------------------------  */}
                    <div className="wrapper" style={{ height: "450px" }}>

                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row" style={{ marginLeft: '10px', marginTop: '20px' }} >

                                    <ToastContainer className="Toast-at-center" />

                                    <div className="col-sm-06 p-0">
                                        <h1 className="m-0 page-title"></h1></div>
                                    {/* <h6 className="taglineTxt">Build Conversation Model</h6> */}
                                    <h6 className="nav-item" style={{ color: '#282a65' }}>Build Voice Model</h6>
                                    <br />
                                </div>
                                <div style={{ display: (this.state.recordsPresent == true) ? "block" : "none" }}>
                                    <div style={{ marginLeft: "10px" }}>Last built with the status {this.state.voiceStatus} on {this.state.lastBuildDate}</div>

                                </div>

                            </div>
                        </div>
                        <br />

                        {/*--------------BUILD-BUTTON--------------------------------------------------------------------------  */}
                        <div className="container-fluid">
                            <div className="row" style={{ marginTop: '-10px', marginLeft: '10px' }}>

                                <div className="col-sm-3 p-0">
                                    <button className="btn action-button"
                                        id="addMsg"
                                        onClick={this.onBuildButton}
                                        disabled={this.state.isVoiceBuildInProgress}
                                        style={{ borderRadius: '4px', width: '30%', height: '30px' }}>Build</button>
                                </div>

                                <div className="col-sm-4 p-0">
                                </div>
                                <div className="col-sm-5 p-0"></div>
                                <h1></h1>
                            </div>
                        </div>

                        {/* --------------------------------PROGRESS-BAR-------------------------------------------------- */}

                        <div className="col-sm-12">
                            <div className="row" style={{ marginTop: '20px', marginLeft: '10px' }}>
                                <div className="col-sm-6 p-0" style={{
                                    display: this.state.voiceProgressBar ? 'block' : 'none',
                                }}>
                                    <div className="nav-item" style={{
                                        color: '#282a65', marginLeft: '8px',
                                        display: this.state.voiceProgressBar ? 'block' : 'none'
                                    }}>Voice Model Build</div>
                                    <div className="col-sm-8" style={{ marginTop: '20px' }}>
                                        <Progress
                                            style={{ display: this.state.voiceProgressBar ? 'block' : 'none' }}
                                            id="build"
                                            width="500px"
                                            height="50px"
                                            rectBorderRadius="1px"
                                            percent={parseInt(this.state.voicePercentage)}
                                        />
                                    </div>
                                    <div style={{ marginTop: '20px' }} className="col-sm-8" name="description">
                                        <textarea
                                            style={{
                                                display: this.state.voiceProgressBar ? 'block' : 'none',
                                                background: 'white', resize: 'none', height: "67px",
                                                fontSize: "0.891em"
                                            }}
                                            className="form-control"
                                            value={this.state.voiceStatus != null ? "Status : " + voiceStatus + '\n' + "Details : "
                                                + this.state.details : ""}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        )
    }


}


// WEBPACK FOOTER //
// ./src/asrUi/AsrBuild.js